import React, { useEffect } from "react";
import PredictiveAnalyticsData from "../components/PredictiveAnalyticsData";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";

const PredictiveAnalytics = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <PredictiveAnalyticsData />
      </div>
    </div>
  );
};

export default PredictiveAnalytics;
